import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

/**
 * Botão de ícone para ações de linha, sempre com tooltip.
 * `pending` = ação ainda não implementada (fica desabilitada com aviso).
 */
export default function ActionIconButton({ title, icon, onClick, color = 'default', disabled = false, pending = false, ...rest }) {
    const isDisabled = disabled || pending;
    const tooltip = pending ? `${title} (em desenvolvimento)` : title;

    return (
        <Tooltip title={tooltip}>
            <span>
                <IconButton
                    size="small"
                    aria-label={title}
                    onClick={onClick}
                    disabled={isDisabled}
                    sx={{
                        color: color === 'default' ? 'text.secondary' : `${color}.main`,
                        border: '1px solid',
                        borderColor: 'divider',
                        bgcolor: 'background.paper',
                        '&:hover': { bgcolor: '#F9FAFB', borderColor: '#D0D5DD' },
                    }}
                    {...rest}
                >
                    {icon}
                </IconButton>
            </span>
        </Tooltip>
    );
}
